var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51053 5.47662L7.51129 5.4773C7.59227 5.54863 7.65471 5.63187 7.69666 5.7213C7.73855 5.8106 7.75958 5.90512 7.75958 5.9997C7.75958 6.09428 7.73855 6.18881 7.69666 6.27811C7.65471 6.36754 7.59227 6.45078 7.51129 6.52211L7.51053 6.52279L2.73748 10.7621C2.73736 10.7622 2.73723 10.7623 2.73711 10.7624C2.6564 10.8335 2.55916 10.891 2.45033 10.9305C2.34133 10.97 2.22377 10.9903 2.10464 10.9897L2.10207 10.9897C1.98293 10.9903 1.86538 10.97 1.75637 10.9305C1.64766 10.891 1.55052 10.8336 1.46986 10.7627C1.30982 10.6194 1.22656 10.4324 1.22656 10.2447C1.22656 10.0569 1.30994 9.86978 1.47019 9.72644C1.4703 9.72634 1.47042 9.72623 1.47053 9.72613L5.45566 6.18662L5.66611 5.9997L5.45566 5.81279L1.47053 2.27328C1.47045 2.2732 1.47037 2.27313 1.47029 2.27306C1.30997 2.1297 1.22656 1.94259 1.22656 1.7547C1.22656 1.56673 1.31006 1.37952 1.47053 1.23613L1.47074 1.23594C1.55104 1.16404 1.64815 1.1056 1.75712 1.06528C1.8661 1.02495 1.98385 1.00391 2.10335 1.00391C2.22286 1.00391 2.34061 1.02495 2.44959 1.06528C2.55856 1.1056 2.65566 1.16404 2.73596 1.23594L2.73596 1.23595L2.73672 1.23662L7.51053 5.47662Z",
    fill: "#333333",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2377bb0d0771f007996e2e8e2df3975c.svg";
export { ForwardRef as ReactComponent };